import { render, staticRenderFns } from "./OfferSectionPageControls.vue?vue&type=template&id=67563f2d&scoped=true&"
import script from "./OfferSectionPageControls.vue?vue&type=script&lang=js&"
export * from "./OfferSectionPageControls.vue?vue&type=script&lang=js&"
import style0 from "./OfferSectionPageControls.vue?vue&type=style&index=0&id=67563f2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67563f2d",
  null
  
)

export default component.exports